// @ts-nocheck
import * as TYPES from '../types';

const initialState = {
    isFetching: false,
    serverErrorsList: [],
    translationsModal: {
        visible: false,
        errorCode: '',
        messageList: [],
    },
    filters: {
        keyword: '',
    },
};

const serverErrors = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case TYPES.SERVER_ERRORS_CHANGED: {
            return {
                ...state,
                serverErrorsList: payload,
                isFetching: false,
            };
        }
        case TYPES.SERVER_ERRORS_FETCHING_CHANGED: {
            return {
                ...state,
                isFetching: payload,
            };
        }
        case TYPES.SERVER_ERRORS_TRANSLATIONS_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                translationsModal: payload,
            };
        }
        case TYPES.SERVER_ERRORS_FILTERS_CHANGED: {
            return {
                ...state,
                filters: payload,
            };
        }
        default:
            return state;
    }
};

export default serverErrors;
